<template>
  <modal :id="modalId" :title="title">
    <form :id="formId" :ref="formId" :action="action" method="POST" role="form">
      <div class="text-center">
        <strong>Are you sure you want to approve application from {{ applicantName }}? This action cannot
          be undone.</strong>
      </div>
      <slot name="notes"></slot>
      <input type="hidden" name="_token" :value="$csrf_token">
    </form>
    <template #footer>
      <button type="button" class="btn btn-white" :disabled="loading" @click="hideModal">
        <i class="fa fa-fw fa-ban"></i> Close
      </button>
      <button type="button" class="btn btn-success" :disabled="loading" @click="submit">
        <i class="fa fa-fw fa-check" v-if="!loading"></i>
        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-else></span>
        {{ title }}
      </button>
    </template>
  </modal>
</template>
<script>
/**
 *
 * Modal dialog used to confirm Application approval.
 *
 * Input properties:
 *
 * modalId        - id attribute of modal dialog.
 * action         - action to submit approve form.
 * applicantName  - applicant name.
 * title          - Button and Modal title
 *
 *
 * Usage examples:
 *
 * <application-approve-modal modalId="'application-approve-modal'"
 *                            action="{{ route('adjusters.applications.approve', compact('application')) }}"
 *                            applicant-name="{{ ... }}"
 *                            title="Approve Application">
 *                            </application-approve-modal>
 *
 */
import HasModal from "../mixins/HasModal";

export default {
  mixins: [HasModal],
  props: {
    applicantName: {
      type: String,
      default: ''
    },
    action: {
      type: String,
      default: ''
    },
    // Custom id for modal component.
    modalId: {
      type: String,
      default: 'application-approve-modal'
    },
    title: {
      type: String,
      default: "Approve Application"
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    formId() {
      return this.modalId + '-form';
    },
  },
  methods: {
    submit() {
      // Submit form.
      this.$refs[this.formId].submit();
      // Set loading state.
      this.loading = true;
    },
  }
}
</script>
